// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4j-0";
export var eligibilityCardNotEligible = "_4j-1";